import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import LinkToEmpenho from '../empenhos/LinkToEmpenho.react';

export class GastoBateriaTable extends Component {
  static propTypes = {
    gastosBateria: PropTypes.object.isRequired,
    idEntidade: PropTypes.any
  };

  renderGastoBateria = gastosBateria => {
    const key = `${gastosBateria.get('numero')}_${gastosBateria.get(
      'data'
    )}_${gastosBateria.get('item')}`;
    const { idEntidade } = this.props;

    return (
      <tr key={key}>
        <td>{gastosBateria.get('numero')}</td>
        <td>{DateUtils.transform(gastosBateria.get('data'))}</td>
        <td>{`${gastosBateria.get('centroDestino')} - ${gastosBateria.get(
          'centroDestinoDescricao'
        )}`}</td>
        <td>
          <LinkToEmpenho
            entidade={idEntidade}
            exercicio={gastosBateria.get('anoEmpenho')}
            empenho={gastosBateria.get('empenho')}
          />
        </td>
        <td>{gastosBateria.get('item')}</td>
        <td className="right">{gastosBateria.get('kmAnterior')}</td>
        <td className="right">{gastosBateria.get('kmAtual')}</td>
        <td className="right">{gastosBateria.get('mediaCombustivel')}</td>
        <td className="right">
          {NumberUtils.format(gastosBateria.get('quantidade'))}
        </td>
        <td className="right">
          {NumberUtils.format(gastosBateria.get('valor'))}
        </td>
        <td className="right">
          {NumberUtils.format(gastosBateria.get('valorTotal'))}
        </td>
      </tr>
    );
  };

  render() {
    const { gastosBateria } = this.props;

    return (
      <Panel title="Gastos com Bateria do Veículo" isTable>
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader
              empty={gastosBateria.isEmpty()}
              texto="Nenhum gasto encontrado."
            >
              <tr>
                <th>Número</th>
                <th>Data</th>
                <th>Centro Consumo</th>
                <th>Empenho</th>
                <th>Ítem</th>
                <th className="right">Km Anterior</th>
                <th className="right">Km</th>
                <th className="right">Média</th>
                <th className="right">Qtde.</th>
                <th className="right">Valor</th>
                <th className="right">Valor Total</th>
              </tr>
            </TableHeader>
            <tbody>{gastosBateria.map(this.renderGastoBateria)}</tbody>
            {!gastosBateria.isEmpty() && (
              <tfoot>
                <tr>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td className="right">
                    <i>Total: </i>
                    <SumListField fieldName="valorTotal" list={gastosBateria} />
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </Panel>
    );
  }
}

export default GastoBateriaTable;
